<template>
  <div class="edit-password-page">
    <div class="page-form">

      <div class="form-item " >
        <div class="label">{{ $t('yuan-mi-ma') }}</div>
        <div class="input"> 
          <input :type="showOldPassword ? 'text' : 'password'" v-model="form.oldPassword" :placeholder="$t('qing-shu-ru-yuan-mi-ma')">
          <div class="adot" @click="changeShowOldPassword">
            <img :src="showOldPassword ? eyeUrl2 : eyeUrl" alt="" >
          </div>
        </div>
      </div>
    
      <div class="form-item" id="passwordDom">
        <div class="label">{{ $t('resetPassword.label1') }}</div>
        <div class="input"> 
          <input :type="showPassword ? 'text' : 'password'" @input="changePassword" v-model="form.password" :placeholder="$t('qing-shu-ru-xin-mi-ma-0')">
          <div class="adot" @click="changeShowPassword">
            <img :src="showPassword ? eyeUrl2 : eyeUrl" alt="" >
          </div>
        </div>
      </div>

      <div class="form-item " >
        <div class="label">{{ $t('resetPassword.label2') }}</div>
        <div class="input"> 
          <input :type="showPassword2 ? 'text' : 'password'"  v-model="form.password2" :placeholder="$t('qing-zai-ci-shu-ru-mi-ma')">
          <div class="adot" @click="changeshowPassword2">
            <img :src="showPassword2 ? eyeUrl2 : eyeUrl" alt="" >
          </div>
        </div>
      </div>

      <div class="form-item " v-if="captchaEnabled" >
        <div class="label">{{ $t('resetPassword.title2') }}</div>
        <div class="input"> 
          <input type="number" inputmode="decimal"  v-model="form.code" :placeholder="$t('qing-shu-ru-yan-zheng-ma-1')">
          <div class="adot long">
            <span class="gray" v-if="isDisabled">{{ $t('zhong-xin-fa-song-timecount', [timeCount]) }}</span>
            <span v-else @click="sendPhoneSms">{{ $t('editPassword.send') }}</span>
          </div>
        </div>
      </div>
      <div class="btn">
        <Button  @click="submit" :class="btnDisabled ? 'gray' : ''">{{ $t('addAddress.btn2') }}</Button>
      </div>

    </div>

    
   


  </div>
</template>
<script>
  import { Button, Popup } from 'vant'
  import { editPassword } from '@/api/setting'
  import { sendAuthCode } from '@/api/user'
  import { getUser } from '@/utils/auth'
  import { isCaptchaEnabled } from '@/utils/captcha'
  export default {
    components: {
      Button,
      Popup,
    },
    data() {
      return {
        form: {
          oldPassword: '',
          password: '',
          password2: '',
          code: ''
        },
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        showPassword: false,
        showPassword2: false,
        showOldPassword: false,
        isDisabled: false,
        showPasswordAuth: false,
        passwordAuthList: [],
        sendTime: ''
      }
    },
    computed: {
      captchaEnabled() {
        return isCaptchaEnabled(this.$store.state.captchaEnable)
      },
      btnDisabled() {
        // 如果验证码关闭,不需要验证码
        if (!this.captchaEnabled) {
          return !(this.form.password && this.form.password2 && this.form.oldPassword)
        }
        return !(this.form.password && this.form.password2 && this.form.oldPassword && this.form.code)
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    methods: {
      back() {
        this.$router.go(-1)
      },
      toLogin() {
        this.$router.push({
          name: 'login'
        })
      },
      submit() {
        if (!this.form.oldPassword) {
         this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder1'))
          return
        }
        if (!this.form.password) {
          this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder2'))
          return
        }
        if (!this.form.password2) {
          this.$toast.fail(this.i18n.t('editPassword.labelPlaceholder3'))
          return
        }

        let form = new FormData()
        form.append('OldPassword', this.form.oldPassword)
        form.append('NewPassword', this.form.password)
        form.append('ConfirmPassword', this.form.password2)
        form.append('Code', this.form.code)
        editPassword(form).then(res => {
          if (res.code == 0) {
            this.$toast.success(this.i18n.t('editPassword.success'))
            // 清空表单
            this.form = {
              oldPassword: '',
              password: '',
              password2: '',
              code: ''
            }
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      changeShowOldPassword() {
        this.showOldPassword = !this.showOldPassword
      },
      changeShowPassword() {
        this.showPassword = !this.showPassword
      },
      changeshowPassword2() {
        this.showPassword2 = !this.showPassword2
      },
      changePassword() {
        this.showPasswordAuth = true
        let password = this.form.password
        let result = []
        if (password.length >= 8 && password.length <= 30) {
          result.push(0)
        }
        if (/[\!\@\#\$\%\^\&\*\(\)\_\=\`\~\,\.\/\\\[\]\{\}\|\-\+]/g.test(password)) {
          result.push(1)
        }
        if (/[A-Z]/g.test(password)) {
          result.push(2)
        }
        if (/[0-9]/g.test(password)) {
          result.push(3)
        }

        this.passwordAuthList = result
      },
      sendPhoneSms(){
        if (!this.captchaEnabled) {
          return
        }
        let form = new FormData()
        form.append('Type', 6)
        sendAuthCode(form).then(res => {
          
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
    },
}
</script>
